export const taskFuseOptions = {
  keys: [
    { name: 'title', weight: 0.7 },
    { name: 'description', weight: 0.3 },
    { name: 'contextName', weight: 0.2 },
    { name: 'projectName', weight: 0.2 },
    { name: 'categoryName', weight: 0.1 }
  ],
  threshold: 0.6,
  includeScore: true,
  minMatchCharLength: 1,
  shouldSort: true,
  findAllMatches: false,
  includeMatches: true,
};

export const projectFuseOptions = {
  keys: [
    { name: 'name', weight: 0.8 },
    { name: 'description', weight: 0.4 },
    { name: 'contextName', weight: 0.2 }
  ],
  threshold: 0.6,
  includeScore: true,
  minMatchCharLength: 1,
  shouldSort: true,
};

export const categoryFuseOptions = {
  keys: [
    { name: 'name', weight: 0.8 },
    { name: 'contextName', weight: 0.2 }
  ],
  threshold: 0.6,
  includeScore: true,
  minMatchCharLength: 1,
  shouldSort: true,
};

export const contextFuseOptions = {
  keys: [{ name: 'name', weight: 1.0 }],
  threshold: 0.6,
  includeScore: true,
  minMatchCharLength: 1,
  shouldSort: true,
};